import SmartImage from "@/components/base/SmartImage";

const techs = [
  {
    code: "01",
    title: "Weather Protection",
    desc: "Water beads and rolls away from the shell surface.",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/f611a582-4342-4eba-8ce2-f39ec1127145_compressed_home-tech-water-beading-red-web.webp",
  },
  {
    code: "02",
    title: "Engineered Construction",
    desc: "Sealed zipper and precise panel construction.",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/86ac82bb-5438-43d2-8a04-298f235438cb_compressed_home-tech-zip-seam-charcoal-web.webp",
  },
  {
    code: "03",
    title: "Breathable Performance",
    desc: "Layered textile structure designed for airflow.",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/771e4ac9-a59d-4db9-8eca-4a06edbe7dc6_compressed_home-tech-breathable-fabric-moss-web.webp",
  },
];

export default function Technology() {
  return (
    <section className="bg-background-50 pt-14 md:pt-16 pb-14 md:pb-16">
      <div className="w-full px-5 md:px-10 mb-6 md:mb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end">
          <div className="lg:col-span-7">
            <p className="text-[10px] tracking-[0.24em] uppercase text-foreground-400 mb-2">Material Story</p>
            <h2 className="text-[28px] md:text-[32px] leading-[1.12] tracking-[-0.01em] font-light text-foreground-50">
              Performance engineered into every fiber.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <p className="text-[15px] md:text-[14px] text-foreground-300 leading-relaxed max-w-md">
              Three material systems, developed across four seasons of alpine, coastal and desert testing.
            </p>
          </div>
        </div>
      </div>

      {/* Full-bleed 3-equal-image band — 0 gap */}
      <div className="grid grid-cols-3 w-full">
        {techs.map((t) => (
          <div key={t.code} className="relative h-[38vh] md:h-[68vh] overflow-hidden bg-background-100">
            <SmartImage src={t.img} alt={t.title} tone="dark" imgClassName="w-full h-full object-cover object-center" />
          </div>
        ))}
      </div>

      {/* Aligned caption strip — 3 equal columns matching band */}
      <div className="grid grid-cols-3 w-full">
        {techs.map((t) => (
          <div key={t.code} className="px-3 md:px-6 pt-4 md:pt-6">
            <div className="flex items-center gap-3 mb-2">
              <span className="text-[10px] tracking-[0.24em] uppercase text-primary-400">{t.code}</span>
              <span className="h-px flex-1 bg-background-200/60"></span>
            </div>
            <h3 className="text-[13px] md:text-[16px] text-foreground-50 font-normal mb-2 leading-tight">{t.title}</h3>
            <p className="hidden md:block text-[13px] text-foreground-300 leading-relaxed max-w-sm">{t.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}